import React from 'react';

import { WELCOME } from 'constants/routes';

import { useGetSelectedWorkspace } from 'hooks/workspace';

import BaseWelcomeModal from 'components/welcome-modal';

// This modal is meant to be undismissable. Users who see this must
// click through to see the intent survey.
const WelcomeModal = () => {
  const selectedWorkspace = useGetSelectedWorkspace();

  const onButtonClick = () => {
    window.location.href = WELCOME;
  };

  return (
    <BaseWelcomeModal
      isOpen
      title={`Welcome to the ${selectedWorkspace?.name} Workspace`}
      subtitle="Tell us a little more about who you are and start collaborating with your team."
      buttonText="Get started"
      onButtonClick={onButtonClick}
    />
  );
};

export default WelcomeModal;
